export class AppAuthJWTToken {
	static readonly NAME = 'app:auth:jwt:token';

	readonly token: string;
	readonly ownerStrategyName: string;
	readonly createdAt: Date;
	private payload: Record<string, unknown> | null = null;

	constructor(token = '', ownerStrategyName = 'email', createdAt?: Date) {
		this.token = token ?? '';
		this.ownerStrategyName = ownerStrategyName;
		this.createdAt = createdAt ?? new Date();
		if (this.token) {
			this.parsePayload();
		}
	}

	getName(): string {
		return AppAuthJWTToken.NAME;
	}

	getOwnerStrategyName(): string {
		return this.ownerStrategyName;
	}

	getCreatedAt(): Date {
		return this.createdAt;
	}

	toString(): string {
		return this.token;
	}

	getValue(): string {
		return this.token;
	}

	getPayload(): Record<string, unknown> {
		if (!this.token) {
			return {};
		}
		if (!this.payload) {
			this.parsePayload();
		}
		return this.payload ?? {};
	}

	isValid(): boolean {
		if (!this.token) {
			return false;
		}
		try {
			const payload = this.getPayload();
			if (payload.exp && typeof payload.exp === 'number') {
				return Date.now() / 1000 < payload.exp;
			}
			return true;
		} catch {
			return false;
		}
	}

	private parsePayload(): void {
		const parts = this.token.split('.');
		if (parts.length !== 3) {
			this.payload = null;
			return;
		}
		const decoded = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
		this.payload = JSON.parse(decoded) as Record<string, unknown>;
	}
}
